import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageShell from '../components/ui/PageShell';
import ResponsiveTable from '../components/ui/ResponsiveTable';
import { Globals } from '../globalfunctions.js';
import { apiClient } from '../utils/apiClient';
import './Transactions.css';

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const [year, month, day] = dateString.split('-');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${day}-${monthNames[parseInt(month, 10) - 1]}-${year}`;
};

function Transactions() {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (Globals.LoginTime === null) navigate('/login');
  }, [navigate]);

  useEffect(() => {
    async function fetchTransactions() {
      setLoading(true);
      try {
        const data = await apiClient.post('/api/transactions/GetTransactions');
        setTransactions(data.map((t) => ({ ...t, UniqueID: t.DESCRIPTION + t.AMOUNT + t.ACCOUNT + t.DATE })));
      } catch (error) {
        console.error('Error fetching transactions:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchTransactions();
  }, []);

  const columns = [
    { key: 'date', label: 'Date', sortable: true, sortValue: (t) => t.date || '', render: (t) => formatDate(t.date) },
    { key: 'description', label: 'Description', sortable: true, sortValue: (t) => t.description || '' },
    { key: 'account', label: 'Account', sortable: true, sortValue: (t) => t.account || '' },
    {
      key: 'amount',
      label: 'Amount',
      sortable: true,
      sortValue: (t) => Number(t.amount) || 0,
      render: (t) => {
        const amount = Number(t.amount) || 0;
        return (
          <span className={`transaction-amount ${amount < 0 ? 'negative' : 'positive'}`}>
            {amount < 0 ? `-£${Math.abs(amount).toFixed(2)}` : `£${amount.toFixed(2)}`}
          </span>
        );
      }
    },
    { key: 'note', label: 'Transaction ID', sortable: true, sortValue: (t) => t.note || '' }
  ];

  return (
    <PageShell>
      <div className="transactions-header">
        <h1>Transactions</h1>
      </div>
      {loading ? (
        <p>Loading transactions...</p>
      ) : (
        <ResponsiveTable columns={columns} rows={transactions} rowKey="UniqueID" emptyMessage="No transactions found." />
      )}
    </PageShell>
  );
}

export default Transactions;
